import { Flex } from '@styles';
import styled, { css } from 'styled-components';

export const formatTime = (time) => {
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(time)) {
    return '00:00';
  }

  const date = new Date(time * 1000);
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds().toString().padStart(2, '0');
  if (hours) {
    return `${hours}:${minutes.toString().padStart(2, '0')} `;
  }
  return `${minutes}:${seconds}`;
};

export const MidContainer = styled(Flex)`
  justify-content: center;
  align-items: center;
`;

export const ControlContainer = styled(Flex)`
  ${({ innerControl, isVisible, theme: { colors } }) => css`
    ${innerControl
      ? `
        display: flex;
        padding: 10px 0;
        justify-content: space-between;
        align-items: center;`
      : `
        background-color: rgba(0, 0, 0, 0.6);
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        transition: 1s;
        opacity: ${isVisible ? 1 : 0};
        transition: 1s;
        left: 0;
        flex-direction: column;
        z-index: 2;
        display: flex;
        justify-content: space-between;

        & span {
          color: ${colors.white[100]};
        }
  `}
  `}
`;

export const StyledFlex = styled(Flex)`
  ${({ height, width }) => css`
    & video {
      width: ${width} !important;
      height: ${height}!important;
    }
  `}
`;
